import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { iniciarAutenticacao } from './autenticacao.init';
import { HttpClient } from '@angular/common/http';
import { AutenticacaoService } from './autenticacao.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class AutenticacaoModule { 
  static forRoot(): ModuleWithProviders<AutenticacaoModule> {
    return {
      ngModule: AutenticacaoModule,
      providers: [
        {
          provide: APP_INITIALIZER, 
          useFactory: iniciarAutenticacao,
          deps: [AutenticacaoService, HttpClient],
          multi: true
        }
      ]
    };
  }
}
